import type { ModelPricing } from '@tcc/shared';
import {
	BAND_LABELS,
	BANDS,
	type Band,
	FIELD_LABELS,
	FIELDS,
	type Field,
	TIER_LABELS,
	TIERS,
	type Tier,
} from '../../pricing';
import { NumCell } from '../NumCell/NumCell';

/** Full Standard / Priority / Flex-Batch × context-band rate grid for one model. */
export function TierGrid({
	name,
	pricing,
	readOnly,
	isChanged,
	onChange,
}: {
	name: string;
	pricing: ModelPricing;
	readOnly: boolean;
	isChanged: (tier: Tier, band: Band, field: Field) => boolean;
	onChange: (tier: Tier, band: Band, field: Field, v: number) => void;
}) {
	return (
		<table className="cfg-rates prc-grid">
			<thead>
				<tr>
					<th rowSpan={2}>Tier</th>
					{BANDS.map((b) => (
						<th key={b} colSpan={FIELDS.length} className="prc-band">
							{BAND_LABELS[b]} input tokens
						</th>
					))}
				</tr>
				<tr>
					{BANDS.map((b) =>
						FIELDS.map((f) => (
							<th key={`${b}-${f}`} className="prc-field">
								{FIELD_LABELS[f]}
							</th>
						)),
					)}
				</tr>
			</thead>
			<tbody>
				{TIERS.map((tier) => (
					<tr key={tier}>
						<th scope="row">{TIER_LABELS[tier]}</th>
						{BANDS.map((band) =>
							FIELDS.map((field) => {
								const v = pricing[tier][band][field];
								const changed = isChanged(tier, band, field);
								return (
									<td key={`${band}-${field}`} className={changed ? 'prc-changed' : undefined}>
										{readOnly ? (
											<span className="cfg-derived">{v}</span>
										) : (
											<NumCell
												value={v}
												step={0.001}
												label={`${name} · ${TIER_LABELS[tier]} · ${BAND_LABELS[band]} · ${FIELD_LABELS[field]}`}
												onChange={(n) => onChange(tier, band, field, n)}
											/>
										)}
									</td>
								);
							}),
						)}
					</tr>
				))}
			</tbody>
		</table>
	);
}
